import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-pay-card-error',
  templateUrl: './pay-card-error.component.html',
  standalone:false,
  styleUrls: ['./pay-card-error.component.scss']
})
export class PayCardErrorComponent implements OnInit {
  prodType: string;

  constructor(private route:ActivatedRoute,private cookieService:CookieService,) { }
  PaymentID
  responsecode:number;
  ErrorText:string='';
  async ngOnInit(): Promise<void> {


    let P =await this.cookieService.get("prodType", true);
    if (P) {
      this.prodType = P;
    }
    this.route.queryParams.subscribe(params => {
      if(params['paymentId']){

        this.PaymentID=params['paymentId'];
      }if(params['responsecode']){
        this.responsecode=params['responsecode'];
        if(this.responsecode==0o5){
          // Please contact card issuer
          this.ErrorText='Your transaction was not complete please contact card issuer'

        }
        else if(this.responsecode==14){
          // Invalid card number
          this.ErrorText='Your transaction was not complete due to invalid card number'

 
        }else if(this.responsecode==33||this.responsecode==54){
          // expired card
          this.ErrorText='Your transaction was not complete because your card is expired'


        }else if(this.responsecode==36 || this.responsecode==62){
          // Restricted card
          this.ErrorText='Your transaction was not complete because your card is restricted'


        }else if(this.responsecode==38){
          // Allowable PIN tries exceeded
          this.ErrorText='You exceeded maximum number of pin entries'

          
        }else if(this.responsecode==51){
// Not sufficient funds
this.ErrorText='Your transaction was not complete due to insufficient funds'



        }else if(this.responsecode==55){
          // Incorrect PIN
          this.ErrorText='Your transaction was not complete due to incorrect PIN'

          
          
                  }else if(this.responsecode==61){
                    // Exceeds withdrawal amount limit
                    this.ErrorText='Your transaction was not complete due to exceeds withdrawal amount limit'

                  }else if(this.responsecode==65){

                    // Exceeds withdrawal frequency limit
                    this.ErrorText='Your transaction was not complete due to exceeds withdrawal frequency limit'



                  }else if(this.responsecode==75){
                    // Allowable number PIN tries exceeded
                    this.ErrorText='Your transaction was not complete due to allowable number PIN tries exceeded'


                  }else if(this.responsecode==76){
                    // Ineligible account
                    this.ErrorText='Your transaction was not complete due to Ineligible account'


                  }else if(this.responsecode==78){
                    // Refer to Issuer
                    this.ErrorText='Your transaction was not complete it indicates an error or problem from the card issuer'


                  }else if(this.responsecode==91){
                    // Issuer is inoperative
                    this.ErrorText='Your transaction was not complete due to Issuer is inoperative'

                  }else{
                    // Your transaction was not complete due to invalid pin
                    this.ErrorText='Your transaction was not complete something went wrong!'


                  }

      }

    });
  }

}
